import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Typography, useTheme } from "@mui/material";

import { PasswordMisuseDomainAlert } from "../service/domain";
import PasswordMisuseAlertTypeChip from "./PasswordMisuseAlertTypeChip";
import { getRemediationIcon } from "./PasswordMisuseRemediationIcons";

type DomainRowProps = {
  domain: PasswordMisuseDomainAlert;
  onSelect: (domainId: number) => void;
  isSelected: boolean;
};

const PasswordMisuseDomainRow = ({
  domain,
  onSelect,
  isSelected,
}: DomainRowProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const latestEvent = domain.latestEvent.toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });

  return (
    <Box
      onClick={() => onSelect(domain.id)}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #e0e0e0",
        cursor: "pointer",
        backgroundColor: isSelected ? "#e0e1ff" : "transparent",
        "&:hover": {
          backgroundColor: isSelected ? "#e0e1ff" : "#f5f5f5",
        },
      }}
    >
      <Box sx={{ flex: 2, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            color: theme.palette.primary.main,
          }}
        >
          {domain.name.length > 35
            ? `${domain.name.slice(0, 35)}...`
            : domain.name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t("Last event")}: {latestEvent}
        </Typography>
      </Box>

      <Box sx={{ flex: 0.5, textAlign: "center" }}>
        <Typography variant="h6" fontWeight="medium">
          {domain.alertCount}
        </Typography>
      </Box>

      <Box sx={{ flex: 0.5, textAlign: "center" }}>
        <Typography variant="h6" fontWeight="medium">
          {domain.userCount}
        </Typography>
      </Box>

      <Box sx={{ flex: 0.7, textAlign: "center" }}>
        <PasswordMisuseAlertTypeChip alertType={domain.type} />
      </Box>

      <Box sx={{ flex: 0.5, textAlign: "center" }}>
        {getRemediationIcon(t, domain.remediation)}
      </Box>
    </Box>
  );
};

export default PasswordMisuseDomainRow;
